import { Button, CircularProgress } from "@mui/material"
import HelpIcon from "@mui/icons-material/Help"
import Modal from "react-bootstrap/Modal"

const ReportDownloadModal = ({ show, onHide, onSelect, loading }) => {
  return (
    <Modal show={show} onHide={loading ? undefined : onHide} size="sm" aria-labelledby="report-download-modal" centered>
      <Modal.Header className=" " closeButton={!loading}>
        <Modal.Title id="report-download-modal" className="text-center w-100">
          <HelpIcon style={{ fontSize: "55px", color: "#7C828C" }} />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4 className="text-center">Download Report</h4>
        <p className="text-center">
          Choose whether to generate a fresh PDF or download the report already saved.
        </p>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center gap-2">
        {loading ? (
          <CircularProgress />
        ) : (
          <>
            <Button
              variant="outlined"
              color="warning"
              className="px-3"
              onClick={() => onSelect(false)}
            >
              Existing Report
            </Button>
            <Button variant="contained" className="btn_bg_secondery px-3" onClick={() => onSelect(true)}>
              Generate New
            </Button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  )
}

export default ReportDownloadModal
